import ProductionDTO from '@src/adapters/dto/production/ProductionDTO';
import useApi, { ApiOptions } from '../base/useApi';
interface Params {
  name: string;
  productionCompanyId: string;
}

interface Result {
  production: ProductionDTO;
}

const options: ApiOptions = {
  method: 'post',
  urlPath: '/production',
  baseUrl: process.env.REACT_APP_API_URL!,
  lazy: false,
};

export const useSaveProduction = (params?: Params) => {
  options.lazy = false;
  return useApi<Params, Result>(options, params);
};

export const useSaveProductionLazy = (params?: Params) => {
  options.lazy = true;
  return useApi<Params, Result>(options, params);
};

export default useSaveProduction;
